<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title class="headline">
        Edytuj
      </v-card-title>
      <v-card-text>
        <v-form
            ref="newForm"
            v-model="valid"
            lazy-validation
            class="dimension--form mt-5 mb-5"
        >
          <v-row>
            <v-col cols="12" md="12" align-self="start" dense>
              <v-text-field
                  v-model="wantBuy.title"
                  class="pt-0"
                  type="text"
                  label="Tytuł"
              ></v-text-field>
              <v-textarea
                  v-model="wantBuy.description"
                  class="pt-0"
                  type="text"
                  label="Opis"
              ></v-textarea>
              <v-text-field
                  v-model="wantBuy.code"
                  class="pt-0"
                  type="text"
                  label="Kod"
              ></v-text-field>
              <v-text-field
                  v-model="wantBuy.quantity"
                  class="pt-0"
                  type="number"
                  label="Ilość"
              ></v-text-field>
              <v-text-field
                  v-model="wantBuy.boughtQuantity"
                  class="pt-0"
                  type="number"
                  label="Zakupiona ilość"
              ></v-text-field>
              <v-autocomplete
                  v-model="wantBuy.category"
                  :items="categories"
                  :search-input.sync="categoryQuery"
                  cache-items
                  item-text="name"
                  item-value="id"
                  flat
                  hide-no-data
                  label="Kategoria"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="onSubmit"
                type="Submit"
                class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                large
            >Zapisz&nbsp;<v-icon size="24">mdi-send</v-icon>
            </v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalEditWantBuy',
  props: {
    item: {},
  },
  created() {
  },
  mounted() {
    this.fetchAllCategories();
  },
  data() {
    return {
      dialog: false,
      form: {
        boughtQuantity: 0,
        quantity: 0,
        code: '',
        category: null,
        title: '',
        description: '',
      },
      categoryQuery: null,
      categories: [],
      categoryAutoComplete: {
        loading: false,
        items: [],
      },
      formRules: {
        email: [(value) => !!value || 'Wpisz adres e-mail'],
      },
      valid: false,
      wantBuy: {
        boughtQuantity: 0,
        quantity: 0,
        code: '',
        category: null,
        title: '',
        description: '',
      },
    }
  },
  watch: {
    categoryQuery(value) {
      this.filterCategories(value);
    },
  },
  methods: {
    open(wantBuy) {
      this.wantBuy = wantBuy;
      this.dialog = true
    },
    fetchAllCategories() {
      if (this.categoryAutoComplete.loading || this.categories.length) {
        return;
      }

      this.categoryAutoComplete.loading = true;
      api.get('/api/categories')
          .then((response) => {
            const mappedCategories = {};
            const categories = response.data.categories;

            categories.forEach((category) => {
              mappedCategories[category.id] = category;
            });
            this.categories = categories;
            this.mappedCategories = mappedCategories;
          })
          .catch((e) => {
            console.error('Error:', e);
          })
          .finally(() => {
            this.categoryAutoComplete.loading = false;
          });
    },
    filterCategories(query) {
      this.categoryAutoComplete.loading = true;
      query = query.toLowerCase().trim();
      const categories = this.categories;
      const mappedCategories = this.mappedCategories;
      const items = [];
      let category, codes, parent, text, breadcrumb;

      for (let i = 0; i < categories.length; i++) {
        category = categories[i];
        codes = category.codes.join(', ').trim();

        if (category.name.toLowerCase().trim().includes(query) ||
            codes.includes(query)
        ) {
          parent = category.parentId
              ? mappedCategories[category.parentId]
              : null;
          text = category.name;

          if (category.requirePhoto) {
            text += ' (WYMAGA ZDJĘCIA)';
          }

          breadcrumb = '';

          if (parent) {
            const parentCategoryName = String(parent.name).trim();

            if ('' !== parentCategoryName) {
              breadcrumb = `W kategorii: ${parentCategoryName}`;
            }
          }

          items.push({
            id: category.id,
            name: category.name,
            text: text,
            codes: codes,
            parentId: category.parentId,
            parent: parent
                ? {
                  id: parent.id,
                  name: parent.name,
                }
                : null,
            unit: category.unit,
            slug: category.slug,
            breadcrumb: breadcrumb,
          });
        }
      }

      this.categoryAutoComplete.items = items;
      this.categoryAutoComplete.loading = false;
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const wantBuy = {
        boughtQuantity: this.wantBuy.boughtQuantity,
        quantity: this.wantBuy.quantity,
        code: this.wantBuy.code,
        category: Number.isInteger(this.wantBuy.category) ? this.wantBuy.category : this.wantBuy.category.id,
        title: this.wantBuy.title,
        description: this.wantBuy.description,
      }
      api
          .put('/api/offer/want-buys/' + this.wantBuy.id, wantBuy)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Zaktualizowano.',
            });
            this.$parent.getList();
            this.dialog = false;
          })
          .catch((error) => {
            console.error('Error when editing a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
